import { Context, useContext } from 'react';

export const useStore = <TStore>(context: Context<TStore | null>): TStore => {
  const store = useContext(context);

  if (!store) {
    throw new Error('useStore must be used within a Store Context.');
  }

  return store;
};
